import * as OfflinePluginRuntime from 'offline-plugin/runtime';

// Montserrat Font Set
import './fonts/montserrat/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w0aXpsog.woff2';
import './fonts/montserrat/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w9aXpsog.woff2';
import './fonts/montserrat/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w2aXpsog.woff2';
import './fonts/montserrat/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w3aXpsog.woff2';
import './fonts/montserrat/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM73w5aXo.woff2';

// OpenSans Font Set
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2';
import './fonts/opensans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2';

// Six Caps Font Set
import './fonts/sixcaps/6ae_4KGrU7VR7bNmaYcV_3Q.woff2';

// Teko Font Set
import './fonts/teko/LYjNdG7kmE0gfaJ9pRtB.woff2';
import './fonts/teko/LYjNdG7kmE0gfa19pRtB.woff2';
import './fonts/teko/LYjNdG7kmE0gfaN9pQ.woff2';

// Glyphicons Font Set
import './fonts/glyphicons/glyphicons-halflings-regular.woff2';

// Landing Page
import './index.html';
import './index.scss';
import './scripts/script';
import './scripts/video';

// GreenSock
import './scripts/animations';

OfflinePluginRuntime.install();
